import React from "react";
import { Box } from "@mui/material";
import image1 from "../../assets/egypt.jpg";
import image2 from "../../assets/elma.jpg";
import image3 from "../../assets/Frenchitas.jpg";
import image4 from "../../assets/Lays.jpg";
import image5 from "../../assets/Leishi.jpg";
import image6 from "../../assets/Margarita.jpg";
import image7 from "../../assets/Sabritas.jpg";
import image8 from "../../assets/SaudiArabia.jpg";
import image9 from "../../assets/Smiths.jpg";
import image10 from "../../assets/Taiwan.jpg";
import image11 from "../../assets/Tapuchips.jpg";
import image12 from "../../assets/Thailand.jpg";
import MobileContainer from "./MobileContainer";

const imageArray = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
];

export default function MobileBanner() {
  return (
    <Box
      sx={{
        position: "relative", // Make the container relative for the absolute positioning of the overlay
        height: "100vh", // Full screen height
      }}
    >
      {/* Background Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(3, 1fr)", // 3 columns for small screens
            sm: "repeat(3, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: "16px",
          padding: "16px",
          height: "100%",
        }}
      >
        {imageArray.map((image, index) => (
          <Box
            key={index}
            sx={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "8px",
              width: "auto",
              height: "auto", // Adjust the height as needed
              opacity: 0.3, // Opacity for the individual image boxes only
            }}
          />
        ))}
      </Box>

      {/* Overlay Component */}
      <Box
        sx={{
          display: "flex",
          padding: "16px",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
          flexShrink: 0,
          borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
          background: "var(--Tokens-Background-Default, #F3F7FD)",
          boxShadow:
            "var(--Elevation-X-Elevation-03, 0px) var(--Elevation-Y-Elevation-03, 2px) var(--Elevation-Blur-Elevation-03, 24px) var(--Elevation-Spread-Elevation-03, 8px) var(--Elevation-Colors-Elevation-03, rgba(0, 92, 188, 0.12))",

          position: "absolute",
          top: "50%", // Center the overlay vertically
          left: "50%", // Center the overlay horizontally
          transform: "translate(-50%, -50%)", // Adjust for exact centering
          zIndex: 2, // Ensure the overlay is on top
          width: "86%", // Set width to 100%
          maxWidth: "500px", // Optional: set a max width to constrain on larger screens
          maxHeight: "calc(100vh - 100px)", // Adjust based on header/footer height
          marginBottom: "60px", // Adjust to avoid overlapping the footer
          overflowY: "auto", // Add scroll when content exceeds max height
          scrollbarWidth: "none", // Firefox: Hide scrollbar
          "&::-webkit-scrollbar": {
            display: "none", // Webkit: Hide scrollbar
          },
        }}
      >
        <MobileContainer data-testid="mobile-container" />
      </Box>
    </Box>
  );
}
